
import api from '@/api';

const namespaced = true;

const state = {
};

const mutations = {
};

const actions = {
  async fetchList() {
    const { data: projects } = await api.get(`/projects`);

    return projects;
  },
  async addProject(noop, project) {
    const { data: dbProject } = await api.post(`/projects`, {
      label: project.label,
      Client_id: project.Client_id,
      Maker_id: project.Maker_id,
    });

    return dbProject;
  },
  async addProjectWithIntervention({ dispatch, rootState }, project) {
    const makerId = rootState[`model/client`].company.id;
    const dbProject = await dispatch(`addProject`, {
      ...project,
      Maker_id: makerId,
    });

    return dispatch(`model/intervention/addIntervention`, {
      $skipNotifications: true,
      description: dbProject.label,
      Client_id: dbProject.Client_id,
      Maker_id: makerId,
      Project_id: dbProject.id,
      Assignee_id: project.Assignee_id || null,
      plannedStartAt: project.plannedStartAt || null,
      plannedEndAt: project.plannedEndAt || null,
      plannedDaysDuration: project.plannedDaysDuration || null,
    }, { root: true });
  },
};

const getters = {
};

export default {
  namespaced, state, mutations, actions, getters,
};
